import { client } from '../../../../../../common-utils/libraries/axios/axios';
import USERS from '../apiUrls';
import { buildUrl } from '../../../../../../common-utils/functions/restUtils';
import userFields from '../../fields/userFields';

/**
 * @param responseData response.data object
 * @param responseData.uuid string
 * @param responseData.email string
 * @param responseData.roles string
 * @param responseData.organization string
 * @param responseData.createdAt string
 * @param responseData.updatedAt string
 * @param responseData.lastLoginAt string
 * @param responseData.profileName string
 * @param responseData.status string
 * @param responseData.permissionList array
 * @param responseData.hasMfa boolean
 *
 * @param responseData.items
 * @param responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};
    const mappedItems = items.map(item => ({
        [userFields.UUID.key]: item[userFields.UUID.key],
        [userFields.EMAIL.key]: item[userFields.EMAIL.key],
        [userFields.PROFILE.key]: item[userFields.PROFILE.key],
        [userFields.ADVANCED_AUTH.key]: item[userFields.ADVANCED_AUTH.key],
        [userFields.ORGANIZATION_UUID.key]: item[userFields.ORGANIZATION_UUID.key],
        [userFields.STATUS.key]: item[userFields.STATUS.key],
        [userFields.CREATED_AT.key]: item[userFields.CREATED_AT.key],
        [userFields.UPDATED_AT.key]: item[userFields.UPDATED_AT.key],
        [userFields.LAST_LOGIN_AT.key]: item[userFields.LAST_LOGIN_AT.key],
        [userFields.PERMISSIONS.key]: item[userFields.PERMISSIONS.key],
        [userFields.ROLES.key]: item[userFields.ROLES.key]
    }));

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetUsers = (query, enabled) => {
    return {
        queryKey: [USERS.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(USERS.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetUsers;